import React from "react";
import styled from "styled-components";
// You can live edit this code below the import statements

import Fade from "react-reveal/Fade";
const Hero = ({ HomeRef }) => {
  return (
    <Fade bottom>
      <Container ref={HomeRef}>
        <Left>
          <Logo>
            <img src="./images/logo1.png" alt="Logo on the hero" />
          </Logo>
          <Content>
            <img
              className="tagline"
              src="https://ik.imagekit.io/euo36lugk/Nutrire/Q1_VtQEa1pEV.png?ik-sdk-version=javascript-1.4.3&updatedAt=1677384207994"
              alt="Quote1"
            />
            <img
              className="tagline1"
              src="https://ik.imagekit.io/euo36lugk/Nutrire/Q2_OCjXeyiGp.png?ik-sdk-version=javascript-1.4.3&updatedAt=1677384208388"
              alt="Quote2"
            />
          </Content>
        </Left>
        <Right>
          <Photos>
            <div className="box1">
              <img
                src="https://ik.imagekit.io/euo36lugk/Nutrire/4_N7WOfxKT1.png?ik-sdk-version=javascript-1.4.3&updatedAt=1677177433247"
                alt=""
              />
            </div>
            <div className="box2">
              <img
                src="https://ik.imagekit.io/euo36lugk/Nutrire/3_sZG16pD_d.png?ik-sdk-version=javascript-1.4.3&updatedAt=1677177433461"
                alt=""
              />
            </div>
            <div className="box3">
              <img
                src="https://ik.imagekit.io/euo36lugk/Nutrire/2_bQ4B7CVP3.png?ik-sdk-version=javascript-1.4.3&updatedAt=1677177433713"
                alt=""
              />
            </div>
            {/* <div class="box4">4</div> */}
            {/* <div class="box5">5</div> */}
            <div className="box6">
              <img
                src="https://ik.imagekit.io/euo36lugk/Nutrire/1_yLHOwe18yE.png?ik-sdk-version=javascript-1.4.3&updatedAt=1677177433464"
                alt=""
              />
            </div>
          </Photos>
        </Right>
      </Container>
    </Fade>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #161616;
  width: 100vw;

  height: 100vh;
  min-height: 800px;
  max-width: 2000px;

  margin: auto;

  @media only screen and (max-width: 815px) {
    width: 100%;
    flex-direction: column;
    height: fit-content;
  }
`;

const Left = styled.div`
  width: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin-bottom: 50px;

  @media (orientation: landscape) {
    margin-left: 20px;
  }
`;

const Right = styled.div`
  width: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* min-height: 100vh; */

  @media only screen and (max-width: 815px) {
    width: 50%;
  }
  margin-bottom: 20px;
`;

const Photos = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 180px);
  grid-template-rows: repeat(3, 130px);
  /* height: 100%; */

  grid-gap: 10px;

  div {
    overflow: hidden;
  }
  div img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .box2 {
    grid-row-start: 1;
    grid-row-end: 3;
    grid-column-start: 2;
    grid-column-end: 3;
  }
  .box3 {
    grid-row-start: 2;
    grid-row-end: 4;

    grid-column-start: 1;
    grid-column-end: 2;
  }
  /* @media only screen and (max-width: 768px) {
    
  } */

  @media only screen and (max-width: 815px) {
    grid-template-columns: repeat(2, 170px);
    grid-template-rows: repeat(3, 130px);
  }
`;

const Logo = styled.div`
  width: 250px;
  margin-bottom: 20px;
  img {
    width: 100%;
  }
`;

const Content = styled.div`
  width: 100%;
  img {
    width: 100%;
    margin-bottom: 15px;
  }
`;

export default Hero;
